import React, { useState } from 'react';
import { CCollapse, CCard, CCardBody, CButton } from '@coreui/react';
import '../css/AshadL.css';
import m1 from '../images/m1.png';
import m2 from '../images/m2.png';
import m3 from '../images/m3.png';
import m4 from '../images/m4.png';
import m5 from '../images/m5.png';
import m6 from '../images/m6.png';
import m7 from '../images/m7.png';


const MayeshaL = () => {
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);
    const [visible5, setVisible5] = useState(false);

    const toggleCard = (index) => {
        switch (index) {
            case 1:
                setVisible1(!visible1);
                break;
            case 2:
                setVisible2(!visible2);
                break;
            case 3:
                setVisible3(!visible3);
                break;
            case 4:
                setVisible4(!visible4);
                break;
            case 5:
                setVisible5(!visible5);
                break;
            default:
                break;
        }
    };

    return (
        <div className="ashad-container">
            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(1);
            }}>
              A story telling robot pediatric rehabilitation
            </a>
            <br />
            <CCollapse visible={visible1}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: A story telling robot pediatric rehabilitation</h5>
      <p>A prototype of a story-telling robot used for children at rehabilitation. Stories can be played by the remote-controlled robot. It is believed that this robot can motivate and help the children reach their therapy goals.</p>

      <h6>Keywords:</h6>
      <img src={m1} alt="img1" />
      <p>
        Therapeutic play, design process, robot, children.
      </p>

      <h6>Objective:</h6>
      <p>
        The objective of the text is to introduce a novel technology that leverages therapeutic play and storytelling to motivate children with disabilities to reach their therapy goals. It emphasizes the importance of family dynamics in therapy success and outlines the development of a working prototype. The goal is to create a product that both excites children and enhances their rehabilitation experience, with a focus on innovative design methodologies and active involvement of children in the design process.
      </p>

      <h6>Conclusion:</h6>
      <p>
        The text highlights the potential of a new technology to motivate children to achieve their therapy goals through therapeutic play. Recognizing the importance of family dynamics in successful therapy, the text suggests that storytelling and play activities, typical home activities involving relatives, siblings, or friends, can be effective motivators. A working prototype has been developed, and scenarios have been created to demonstrate how the technology can be utilized with challenged children.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(1)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(2);
            }}>
                Toy Design based on multiple intelligence theory: Research case of spatial intelligence children’s toy design
            </a>
            <br />
            <CCollapse visible={visible2}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Children’s Toy Design based on multiple intelligence theory - Research case of ‘’spatial intelligence children’s toy design”</h5>

      <h6>Overview:</h6>
      <p>
        The theory of multiple intelligences, which gained popularity worldwide in the mid-1980s and was initially proposed by Howard Gardner in his 1983 book "The Structure of Intelligence: The Theory of Multiple Intelligences." This theory presents a new perspective on human intelligence, departing from the traditional view. According to multiple intelligences theory, intelligence is not a single ability but a collection of various abilities, each existing independently rather than in an integrated manner. Gardner's work marked a significant departure from traditional notions of intelligence.
      </p>

      <h6>Design Model:</h6>
      <p>
        The FBS (function-behavior-structure) model, introduced by GERO in 1990. This model serves as a design process framework that involves analyzing three key variables in the design process: function, behavior, and structure. Through step-by-step mapping and analysis of these variables, the FBS model aids in transforming abstract conceptual design problems into more concrete and manageable solutions.
      </p>
      <img src={m3} alt="img2" />
      <img src={m4} alt="" />

      <h6>Conclusion:</h6>
      <p>
        This thesis builds upon the theory of multiple intelligences and introduces the RBFES children's toy design model, using spatial intelligence toys as an illustrative example. It emphasizes the valuable role of multiple intelligence theory in guiding the design of children's toys. The study employs comprehensive user research and emotional design theory to enhance the existing FBS design model and identify effective strategies for promoting children's multiple intelligences through toy design. The research contributes fresh insights and possibilities for the development of such products. Nevertheless, the study faces certain limitations due to project time constraints. These include a limited number of user samples and the omission of specific intelligence exercise needs and methods for special children, such as those with mental disabilities.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(2)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(3);
            }}>
                A robot-based digital storytelling approach to enhancing EFL learners’ multimodal storytelling ability
            </a>
            <br />
            <CCollapse visible={visible3}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: A robot-based digital storytelling approach to enhancing EFL learners’ multimodal storytelling ability and narrative engagement</h5>

      <h6>Overview:</h6>
      <p>
        Digital technology has revolutionized language education by introducing new possibilities. Multimodal literacy, the capacity to comprehend and create content in various modes, plays a pivotal role in this transformation. While digital storytelling (DST) has been widely employed in second language instruction, To address this, a study proposed a robot-based DST (robot-DST) approach to enhance interaction and engagement. The study conducted a quasi-experiment in an EFL course with two groups: one using robot-DST and the other using conventional animation-based DST (CA-DST). The results demonstrated that robot-DST significantly reduced students' communication apprehension, improved English speaking and storytelling abilities.
      </p>
      <img src={m5} alt="img3" />

      <h6>Conclusion:</h6>
      <p>
        In conclusion, the introduction of digital technology into language education has opened up new possibilities, with a focus on multimodal literacy. Digital storytelling (DST) has been widely used in second language instruction, and a study introduced a robot-based DST (robot-DST) approach to enhance interaction and engagement. The study's quasi-experiment showed that robot-DST had a significant impact, reducing students' communication apprehension and improving their English speaking and storytelling abilities when compared to the conventional animation-based DST (CA-DST).
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(3)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(4);
            }}>
                Using Robots with Storytelling and Drama Activities in Science Education
            </a>
            <br />
            <CCollapse visible={visible4}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Using Robots with Storytelling and Drama Activities in Science Education</h5>

      <h6>Overview:</h6>
      <p>
        Storytelling and drama are effective teaching tools for student engagement, and when combined with robot actors, they offer a multisensory learning experience. This paper investigates the potential and challenges of using storytelling and drama activities with robots in science education. Two experiences with robot-assisted storytelling and drama in science education are discussed, highlighting their role in enhancing science concept development, fostering students' skills, creating a positive classroom atmosphere, and boosting attention and motivation.
      </p>
      <img src={m6} alt="img4" />

      <h6>Objective:</h6>
      <p>
        The main objective of using storytelling and drama with robot actors in science education is to provide an effective and engaging learning experience that enhances science concept development, fosters valuable skills, creates a positive classroom atmosphere, and boosts students' attention and motivation. While there may be challenges associated with implementing these methods, the potential benefits for science education are significant, making it a promising approach to teaching and learning in this field.
      </p>

      <h6>Conclusion:</h6>
      <p>
        The study also emphasizes the importance of designing affordable expressive actor robots that can be easily customized and the development of user-friendly multi-robot programming interfaces for scripting and programming the robots.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(4)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(5);
            }}>
                Personalized Robot Storytelling Companion
            </a>
            <br />
            <CCollapse visible={visible5}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Personalized Robot Storytelling Companion</h5>

      <h6>Overview:</h6>
      <p>
        It is certain in this study that researchers explore the potential of using a social robot as a peer to collaboratively exchange stories with children, with a focus on enhancing their linguistic and storytelling skills. They employ machine learning algorithms to develop Companion AI, allowing robots to learn actions that aid young learners and maintain their engagement. Additionally, the research delves into the customization of interactions, recognizing that each child's learning style and engagement preferences are unique. This work aims to investigate how social robots can adapt and personalize their interactions with each child over multiple encounters, creating a more effective and tailored learning experience.
      </p>
        <img src={m7} alt="img5" />

      <h6>Objective:</h6>
      <p>
        The primary objective of this project is to leverage machine learning algorithms to develop "Companion AI" for robots, enabling them to act as helpful peers for young learners, focusing on improving children's storytelling skills and linguistic development.
      </p>

      <h6>Conclusion:</h6>
      <p>
        In conclusion, the project represents a significant step in the field of human-robot interaction and educational technology. By using social robots to personalize interactions and enhance children's linguistic and storytelling skills, it offers a promising approach to improving early childhood education and addressing educational inequalities. The positive results from the project suggest that this innovative use of technology has the potential to make a meaningful impact on young learners' development.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(5)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>
        </div>
    );
};

export default MayeshaL;
